import { render, staticRenderFns } from "./PerformanceLinks.vue?vue&type=template&id=754f0832&"
import script from "./PerformanceLinks.vue?vue&type=script&lang=js&"
export * from "./PerformanceLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports